import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, MapPinIcon } from 'lucide-react';
import { statusLabels, statusOrder, type CitizenRequest, type RequestStatus } from '../../data/demandes';
import { useRequests } from '../../contexts/RequestsContext';
export function StatusProgress({
  status
}: {
  status: RequestStatus;
}) {
  const currentIndex = statusOrder.indexOf(status);
  return <ol className="flex items-center gap-2" aria-label={`Statut : ${statusLabels[status]}`} data-id="element-1369" data-mp="jtwd7vvei23p">
      {statusOrder.map((step, index) => {
      const reached = index <= currentIndex;
      return <li key={step} className="flex items-center gap-2" data-id="element-1370" data-mp="stjg6m3s3fyv" data-mpi={index}>
            <span className={`rounded-full px-3 py-1 text-xs font-bold ${index === currentIndex ? 'bg-ville-indigo text-white' : reached ? 'bg-ville-indigo-soft text-ville-indigo' : 'bg-slate-100 text-slate-400'}`} data-id="element-1371" data-mp="xsw131b3acyt">
              {statusLabels[step]}
            </span>
            {index < statusOrder.length - 1 && <span className={`h-0.5 w-5 rounded-full ${index < currentIndex ? 'bg-ville-indigo' : 'bg-slate-200'}`} aria-hidden="true" data-id="element-1372" data-mp="ictym3v39owy" />}
          </li>;
    })}
    </ol>;
}

/** Nombre de messages de la Ville qui attendent une réponse du citoyen. */
function pendingCount(request: CitizenRequest) {
  return request.messages.filter(message => message.author === 'ville' && message.awaiting).length;
}
export function RequestList() {
  const {
    requests
  } = useRequests();
  return <section aria-labelledby="mes-demandes-titre" data-id="element-1373" data-mp="s3ovs39vi8x6">
      <h2 id="mes-demandes-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1374" data-mp="s2wxulsszz3q">
        Mes demandes
      </h2>
      <p className="mt-1 text-[15px] text-slate-600" data-id="element-1375" data-mp="3hqe7c0ljdl4b">Suivez l’avancement de ce que vous avez signalé.</p>

      <ul className="mt-6 space-y-3" data-id="element-1376" data-mp="3eatcja02xia0">
        {requests.map(request => <li key={request.id} data-id="element-1377" data-mp="3e8qdk0gy8et5">
            <Link to={`/mes-demandes/${request.id}`} className="group flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1378" data-mp="3j9nyulx99oyv">
              <div className="min-w-0 flex-1" data-id="element-1379" data-mp="2viqv3wfm5xyp">
                <div className="flex flex-wrap items-center gap-2" data-id="element-1380" data-mp="30as2p51u70ie">
                  <h3 className="text-[15px] font-extrabold text-ville-navy" data-id="element-1381" data-mp="30d4su5hr0h6j">{request.title}</h3>
                  <span className="text-xs font-semibold text-slate-400" data-id="element-1382" data-mp="2lk2nzsp6339s">{request.reference}</span>
                </div>
                <p className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm text-slate-500" data-id="element-1383" data-mp="2clh9q9qqaaet">
                  <span className="flex items-center gap-1.5" data-id="element-1384" data-mp="2hkkd7pr288ko">
                    <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-1385" data-mp="2hjr4ij8jj8zw" />
                    {request.address}
                  </span>
                  <span data-id="element-1386" data-mp="1sznueyf1r194">{request.submittedOn}</span>
                </p>
                <div className="mt-3" data-id="element-1387" data-mp="1t1s5c0bd50iw">
                  <span className="rounded-full bg-ville-indigo px-3 py-1 text-xs font-bold text-white" data-id="element-1388" data-mp="26zyixusvw3r4">
                    <span className="sr-only" data-id="element-1389" data-mp="22xbw68b2l90s">Statut : </span>
                    {statusLabels[request.status]}
                  </span>
                </div>
              </div>
              {pendingCount(request) > 0 && <span className="inline-flex items-center gap-2 text-xs font-bold text-ville-navy" data-id="element-1390" data-mp="2bxqo3qijhmd9">
                  Réponse attendue
                  <span className="grid h-5 min-w-5 place-items-center rounded-full bg-ville-lime px-1.5 text-[11px] font-bold text-ville-navy" data-id="element-1391" data-mp="2qp8z19wjkqpr">
                    {pendingCount(request)}
                  </span>
                </span>}
              <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400 transition-colors duration-150 ease-ville group-hover:text-ville-indigo" aria-hidden="true" data-id="element-1392" data-mp="2uq2nq5ht69jp" />
            </Link>
          </li>)}
      </ul>
    </section>;
}